import splitbee from "@splitbee/web";
import posthog from "posthog-js";
import { AnalyticsEvents } from "./analyticsEvents";
import { normalizeAnalyticsEvent } from "./normalizeAnalyticsEvent";

export type AnalyticsProperties = Record<string, string | number | boolean | null | undefined>;

const normalizeAndCapture = (rawEvent: string, properties: AnalyticsProperties = {}) => {
  const { event, properties: normalizedProperties } = normalizeAnalyticsEvent(rawEvent, properties);
  posthog.capture(event, normalizedProperties);
  return event;
};

export const logEvent = (event: string, properties: AnalyticsProperties = {}) => {
  splitbee.track(event);
  return normalizeAndCapture(event, properties);
};

/** @deprecated Prefer logEvent */
export const logEventWithProperties = (event: string, properties: AnalyticsProperties) => {
  logEvent(event, properties || {});
};

export const identifyUser = (
  userId: string,
  traits: AnalyticsProperties = {}
) => {
  if (!userId) return;
  posthog.identify(userId, traits);
};

export const resetAnalyticsUser = () => {
  posthog.reset();
};

export const trackPageView = (path?: string) => {
  const properties: AnalyticsProperties = {};
  if (typeof window !== "undefined") {
    properties.path = path || window.location.pathname;
    properties.search = window.location.search;
    properties.hash = window.location.hash;
  }
  logEvent("$pageview", properties);
};

/** Fires canonical completion + keeps legacy export event names via normalization. */
export const trackVideoExported = (
  legacyEvent: string,
  preset: string,
  properties: AnalyticsProperties = {}
) => {
  logEvent(legacyEvent);
  logEvent(AnalyticsEvents.VIDEO_EXPORTED, { preset, ...properties });
};

export default () => {
  return null;
};